import { createSlice } from '@reduxjs/toolkit'

export const UserPermissionsSlice = createSlice({
  name: 'userPermissions',
  initialState: {
    value: {},
  },
  reducers: {
    updatePermissions: (state, action) => {
      state.value = action.payload;
    },
    removePermissions: (state) => {
      state.value = {};
    },
  },
});

// Action creators are generated for each case reducer function
export const { updatePermissions, removePermissions } = UserPermissionsSlice.actions

export const selectUserPermissionsValue = state => state.userPermissions.value;

export default UserPermissionsSlice.reducer